import { useEffect, useState } from "react";
import {
  DesignTokens,
  Row,
  Col,
  RangePicker,
  DatePicker,
} from "melco-ui";

import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash-es";
import { ProductsFilter } from "../../licenses/filter/ProductsFilter";
import { Search } from "../../search/Search";
import dayjs from "dayjs";
import { PaymentsStatusFilter } from "../filter/PaymentsStatusFilter";
import styled from "styled-components";
import { RefferalSalesPersonsFilter } from "../../licensemanager/RefferalSalesPersonsFilter";
import { PaymentsModeFilter } from "../filter/PaymentsModeFilter";
import { PaymentProductsFilter } from "../../licenses/filter/PaymentProductsFilter";
import { PaymentsOrgUnitFilter } from "../filter/PaymentsOrgUnitFilter";

const { spacings } = DesignTokens;

// On First time visit on the payments screen default Filter should be selected Manual and Automatic
const DEFAULT_MODES = ["1", "2"]; // Automatic + Manual

export type PaymentsListFiltersType = {
  searchText?: string;
  products?: string;
  serviceStartTimeStamp?: Date;
  serviceEndTimeStamp?: Date;
  melcoCustomerId?: string;
  transactionTimeStamp?: Date;
  userName?: string;
  statusList?: string;
  affiliateList?: string;
  paymentMode?: string[];
  orgUnit?: string[];
};

const BoxWrapper = styled.div`
max-width: 300px;
min-width: 225px;
`;

type PaymentsListFilterProps = {
  onFiltersChange: (filters: PaymentsListFiltersType | undefined) => void;
};

export const PaymentsListFilter: React.FC<PaymentsListFilterProps> = ({
  onFiltersChange,
}) => {
  const { t } = useTranslation();
  const [paymentsFilter, setPaymentsFilter] = useState<
    PaymentsListFiltersType | undefined
  >({
    paymentMode: DEFAULT_MODES,
    orgUnit: undefined
  });

  const [searchValue, setSearchValue] = useState("");
  const [userName, setUserName] = useState("");
  const [melcoCustomerIdValue, setMelcoCustomerIdValue] = useState("")
  useEffect(() => {
    onFiltersChange(paymentsFilter);
  }, [paymentsFilter, onFiltersChange]);


  return (
    <div>
      <Row gutter={[spacings.middle, spacings.middle]}>
        <Col xs={24} xl={6} md={6}>
          <Search
            onSearchInputChange={(value) => {
              setPaymentsFilter((prevFilter) => {
                return { ...prevFilter, searchText: value };
              });
            }}
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
          />
        </Col>
        <Col xs={24} xl={6} md={6}>
          <Search
            onSearchInputChange={(value) => {
              setPaymentsFilter((prevFilter) => {
                return { ...prevFilter, melcoCustomerId: value };
              });
            }}
            placeholder={t("payments.table.column.melco_customer_id")}
            onChange={(e) => setMelcoCustomerIdValue(e.target.value)}
            value={melcoCustomerIdValue}
          />
        </Col>

        <Col xs={24} xl={6} md={6}>
          <Search
            onSearchInputChange={(value) => {
              setPaymentsFilter((prevFilter) => {
                return { ...prevFilter, userName: value };
              });
            }}
            placeholder={t("payments.table.column.user_name")}
            onChange={(e) => setUserName(e.target.value)}
            value={userName}
          />
        </Col>
        <Col xs={24} xl={6} md={6}>
          <PaymentProductsFilter
            onChange={async (value) => {
              //await clearProductsFilter();
              setPaymentsFilter((prevFilter) => {
                return {
                  ...prevFilter,
                  products: !isEmpty(value) ? value : undefined,
                };
              });
            }}
            value={paymentsFilter?.products ?? undefined}
          //onClear={clearProductsFilter}
          />
        </Col>
        <Col xs={24} xl={6} md={6}>

          <BoxWrapper>
            <DatePicker
              name="transactionDate"
              placeholder={t("payments.table.column.payment_entry_date")}
              format={"L"}
              style={{ width: "100%" }}
              onChange={(value) => {
                const transactionTimeStamp =
                  (value && value.startOf("day").toDate()) ??
                  undefined;
                setPaymentsFilter((prevFilter) => {
                  return {
                    ...prevFilter,
                    transactionTimeStamp: transactionTimeStamp
                  }
                })
              }}
              value={paymentsFilter?.transactionTimeStamp && dayjs(paymentsFilter?.transactionTimeStamp)}
            />
          </BoxWrapper>
        </Col>
        <Col xs={24} xl={6} md={6}>

          <BoxWrapper>
            <RangePicker
              format={"L"}
              onChange={(value) => {
                const serviceStartTimeStamp =
                  (value && value[0] && value[0].startOf("day").toDate()) ??
                  undefined;
                const serviceEndTimeStamp =
                  (value && value[1] && value[1].endOf("day").toDate()) ??
                  undefined;

                setPaymentsFilter((prevFilter) => {
                  return {
                    ...prevFilter,
                    serviceStartTimeStamp,
                    serviceEndTimeStamp,
                  };
                });
              }}
              value={
                paymentsFilter?.serviceStartTimeStamp &&
                paymentsFilter?.serviceEndTimeStamp && [
                  dayjs(paymentsFilter?.serviceStartTimeStamp),
                  dayjs(paymentsFilter?.serviceEndTimeStamp),
                ]
              }
              placeholder={[
                t("orders_list.filter.start_timestamp.placeholder"),
                t("orders_list.filter.end_timestamp.placeholder"),
              ]}
            />
          </BoxWrapper>
        </Col>
        <Col xs={24} xl={6} md={6}>
          <RefferalSalesPersonsFilter onChange={(value) => {
            setPaymentsFilter((prevFilter) => {
              return {
                ...prevFilter,
                affiliateList: !isEmpty(value) ? value : undefined
              }
            })
          }} />
        </Col>
        <Col xs={24} xl={6} md={6}>
          <PaymentsStatusFilter
            onChange={(value) => {
              setPaymentsFilter((prevFilter) => {
                return {
                  ...prevFilter,
                  statusList: !isEmpty(value) ? value : undefined
                }
              })
            }} />
        </Col>

        <Col xs={24} xl={6} md={6}>
          <PaymentsModeFilter
            value={paymentsFilter?.paymentMode} // CONTROLLED VALUE
            onChange={(value) => {
              setPaymentsFilter((prevFilter) => {
                return {
                  ...prevFilter,
                  paymentMode: !isEmpty(value) ? value : undefined
                }
              })
            }} />
        </Col>

        <Col xs={24} xl={6} md={6}>
          <PaymentsOrgUnitFilter
            value={paymentsFilter?.orgUnit} // CONTROLLED VALUE
            onChange={(value) => {
              setPaymentsFilter((prevFilter) => {
                return {
                  ...prevFilter,
                  orgUnit: !isEmpty(value) ? value : undefined
                }
              })
            }} />
        </Col>
      </Row>

    </div>
  );
};
